webpackJsonp([32,35],{

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(103),
	  /* template */
	  __webpack_require__(272),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 102:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    number: {
	      default: 0
	    },
	
	    animateTime: {
	      default: 4000
	    },
	
	    length: {
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      valueSelf: this.number,
	      timer: null
	    };
	  },
	
	  watch: {
	    number: function number(newval, oldval) {
	      var _this = this;
	
	      clearInterval(this.timer);
	
	      var distance = newval - oldval;
	      var steps = parseInt(24 * this.animateTime / 1000);
	
	      this.timer = setInterval(function () {
	        var speed = 0;
	        if (Math.abs(distance) >= steps) {
	          speed = parseInt(distance / steps);
	        } else {
	          speed = Math.abs(distance) / distance;
	        }
	
	        if (Math.abs(_this.valueSelf - newval) <= Math.abs(speed)) {
	
	          _this.valueSelf = newval;
	          clearInterval(_this.timer);
	        } else {
	          _this.valueSelf += speed;
	        }
	      }, 1000 / 24);
	    }
	  },
	  computed: {
	    valueStr: function valueStr() {
	      if (this.length > 0) {
	        return (Array(this.length).join(0) + this.valueSelf).slice(-this.length);
	      } else {
	        return this.valueSelf;
	      }
	    }
	  },
	  ready: function ready() {},
	  attached: function attached() {},
	
	  methods: {},
	  components: {}
	};

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _animateNumber = __webpack_require__(194);
	
	var _animateNumber2 = _interopRequireDefault(_animateNumber);
	
	var _menuVertical = __webpack_require__(13);
	
	var _menuVertical2 = _interopRequireDefault(_menuVertical);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: '',
	  components: {
	    AnimateNumber: _animateNumber2.default,
	    menuVertical: _menuVertical2.default
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    setInterval(function () {
	      _this.val += 10;
	    }, 2000);
	  },
	
	  methods: {
	    change: function change(val) {
	      this.val = val;
	    }
	  },
	  data: function data() {
	    return {
	      val: 1
	    };
	  }
	};

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(102),
	  /* template */
	  __webpack_require__(248),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 248:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_vm._v("\n  " + _vm._s(_vm.valueStr) + "\n")])
	},staticRenderFns: []}

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "list list-box p0002"
	  }, [_c('li', {
	    staticClass: "list-item"
	  }, [_c('menu-vertical', [_c('span', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('animate-number', {
	    attrs: {
	      "number": _vm.val
	    }
	  })], 1)])], 1)])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/32.2229469098591c57d67c.js